import React, { useState } from 'react';
import './style.scss';
import './logo.svg';
import InvalidEmailModal from './modals/InvalidEmailModal';
import useRemote from './hooks/useRemote';
import SchoolAccountModal from './modals/SchoolAccountModal';
import PersonalAccountModal from './modals/PersonalAccountModal';
import CodeVerificationModal from './modals/CodeVerificationModal';
import Page from './components/Page';
import Hero from './components/Hero';

const VALID_EMAIL = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;			// eslint-disable-line no-useless-escape

const Signup = ({setModal})=>{

	const [ email, setEmail ] = useState("");
	const [ loading, setLoading ] = useState(false);

	const remote = useRemote();

	const processEmail = () => {
		if (!email.match(VALID_EMAIL)) {
			setModal(<InvalidEmailModal email={email} closeModal={()=>setModal(null)} />);
		} else {
			setLoading(true);
			remote.checkEmailForLogin(email).then(response=>{
				if (response.noAccount) {
					if (response.school) {
						setModal(<SchoolAccountModal school={response.school} proceed={()=>registerSchool(response.school, response.checksum, email)} closeModal={()=>{setModal(null); setLoading(false);}} />);
					} else {
						setModal(<PersonalAccountModal email={email} proceed={()=>registerPersonal(email)} closeModal={()=>{setModal(null); setLoading(false);}} />);
					}
				} else {
					//Account already exists (yay!)
					//..but if we're here it means there's no remember me token, so do a 2fa
					remote.send2FA(email).then(response=>{
						const code = response.code;
						setModal(<CodeVerificationModal email={email} checkCode={enteredCode=>remote.verify2FA(email, code, enteredCode)} proceed={enteredCode=>login(email, code, enteredCode)} closeModal={()=>{setModal(null); setLoading(false);}} />);
					});
				}
			});
		}
	}

	const registerPersonal = (email) => {
		register(null, null, email);
	}
	const registerSchool = (school, checksum, email) => {
		register(school, checksum, email);
	}
	const register = (school, checksum, email) => {
		remote.send2FA(email).then(response=>{
			const code = response.code;
			setModal(<CodeVerificationModal email={email} checkCode={enteredCode=>remote.verify2FA(email, code, enteredCode)} proceed={enteredCode=>createAccount(school, checksum, email, code, enteredCode)} closeModal={()=>{setModal(null); setLoading(false);}} />);
		});
	}

	const createAccount = (school, checksum, email, expectedCode, enteredCode) => {
		//We send the code back for server side verification
		const data = {
			school,
			checksum,
			email,
			enteredCode,
			expectedCode
		};

		remote.createAccount(data);
	}

	const login = (email, expectedCode, enteredCode) => {
		//We send the code back for server side verification
		const data = {
			email,
			enteredCode,
			expectedCode
		};

		remote.login(data);
	}

	return <div className="signup">
		<header>Sign In/Sign Up</header>
		<div className="data-line">
			<input name="email" value={email} onChange={e=>setEmail(e.target.value.toLowerCase())} placeholder="Enter your email address" autoFocus={true} />
			<button onClick={processEmail} disabled={loading}>{loading ? "Please wait..." : <>Continue &raquo;</>}</button>
		</div>
	</div>
}

const LoginPage = ()=>{
	return <Page>
		<Hero>
			<a target="_blank" href={`${process.env.PUBLIC_URL}/sample.pdf`}><img alt="Thumbnail of an example homework sheet" src={`${process.env.PUBLIC_URL}/sample-thumbnail.png`} /></a>
			<div>
				<div><strong>Simple</strong>, secure, customised homework sheets for primary level maths.
				Each sheet is custom built for a student at the level that they are at, with trackable 
				progress via an easy to use spreadsheet.  And we know how important privacy is, so no 
				student data is ever stored!</div>
				<div>Download a sample <a target="_blank" href={`${process.env.PUBLIC_URL}/sample.pdf`}>here</a> or sign up below for your free trial.</div>
			</div>
		</Hero>

		<Signup />

	</Page>;
}

export default LoginPage;